import { FileData } from '@/types/file';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { FileDataTableRowActions } from './file-data-table-row-actions';

interface ColumnOptions {
  onDelete: (file: FileData) => Promise<void>;
}

export const columns = ({ onDelete }: ColumnOptions): ColumnDef<FileData>[] => [
  {
    accessorKey: 'url',
    header: 'Preview',
    cell: ({ row }) => {
      const url = row.getValue('url') as string;
      return (
        <div className="flex items-center">
          <div className="h-12 w-12 overflow-hidden rounded-sm border bg-muted">
            <img src={url} alt={row.getValue('name')} className="h-full w-full object-cover" />
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'size',
    header: 'Size',
    cell: ({ row }) => {
      const file = row.original;
      return (
        <div className="text-center">{`${((file.metadata?.size ?? file.size) / 1024).toFixed(1)} KB`}</div>
      );
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Upload Date',
    cell: ({ row }) => {
      return <div>{format(new Date(row.getValue('created_at')), 'MMM dd, yyyy')}</div>;
    },
  },
  {
    id: 'actions',
    cell: ({ row }) => <FileDataTableRowActions file={row.original} onDelete={onDelete} />,
  },
];
